import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AppRouter } from './components/layout/AppRouter'
import { ErrorBoundary } from './components/ui/ErrorBoundary'
import PWAUpdatePrompt from './components/PWAUpdatePrompt'
import { useP2PStore } from './store/p2pStore'
import { AvatarPreviewProvider } from './contexts/AvatarPreviewContext'
import './styles/globals.css'

function App() {
  // const loadPersistedAvatar = useP2PStore(state => state.loadPersistedAvatar)
  const localSelfta = useP2PStore(state => state.localSelfta)
  
  // CRITICAL FIX: Remove competing avatar loading from App.tsx
  // The onRehydrateStorage callback in p2pStore now handles avatar loading
  // This prevents race conditions and data overwriting
  useEffect(() => {
    console.log('🚀 App initializing - avatar data handled by Zustand rehydration')
    // No need to manually load avatar here anymore
  }, [])
  
  // Debug logging for avatar state changes
  useEffect(() => {
    if (localSelfta) {
      console.log('👤 App: Avatar state updated:', {
        alias: localSelfta.alias,
        hasImage: !!localSelfta.profileImage,
        imageSize: localSelfta.profileImage?.length || 0
      })
    } else {
      console.log('👤 App: No avatar data in store')
    }
  }, [localSelfta])
  return (
    <ErrorBoundary>
      <AvatarPreviewProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-secondary-50 text-secondary-900">
            <AppRouter />
            <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#ffffff',
                color: '#1e293b',
                boxShadow: '0 10px 40px -10px rgba(0, 0, 0, 0.15), 0 20px 25px -5px rgba(0, 0, 0, 0.1)',
              },
              success: {
                iconTheme: {
                  primary: '#22c55e',
                  secondary: '#ffffff',
                },
              },
              error: {
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#ffffff',
                },
              },
            }}
          />
            <PWAUpdatePrompt />
          </div>
        </BrowserRouter>
      </AvatarPreviewProvider>
    </ErrorBoundary>
  )
}

export default App